<template>
  <card-wrapper class="py-8">
    <number-chart :is-loading="isLoading"
                  :value="total"
                  :title="title"
                  :hint="hint"
                  id="automation-rate-number"
    />
  </card-wrapper>
</template>

<script>
import NumberChart from '@/components/analytics/charts/NumberChart'
import CardWrapper from '@/components/base-components/CardWrapper'
import analyticsFilterModule from '@/store/modules/analytics-filter.module'
import { GRANULARITY_REQUEST } from '@/utils/filter.constants'
import { CHART_TEXT } from '@/utils/text.constants'
import analyticsModule from '@/store/modules/analytics.module'

export default {
  name: 'AutomationRateNumberChart',
  components: {
    NumberChart,
    CardWrapper
  },

  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    granularity: analyticsFilterModule.getGranularity,
    requestTotal: analyticsModule.getRequestTotal,
    contactTotal: analyticsModule.getContactTotal,

    total() {
      return GRANULARITY_REQUEST === this.granularity ? this.requestTotal : this.contactTotal
    },

    title() {
      return GRANULARITY_REQUEST === this.granularity ? 'Number of Requests' : 'Number of Contacts'
    },

    hint() {
      return GRANULARITY_REQUEST === this.granularity ? CHART_TEXT.REQUEST_HINT : CHART_TEXT.CONTACT_HINT
    }
  }
}
</script>
